import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=037f35eb&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=037f35eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037f35eb",
  null
  
)

export default component.exports